import moment from "moment";

export const DUPLICATED_CITY_PAIR_ERROR_KEY = 'DUPLICATED_CITY_PAIR_ERROR_KEY';
export const DATES_OVERLAPPING_ERROR_KEY = 'DATES_OVERLAPPING_ERROR_KEY';
export const AIRPORTS_SELECTOR_TARGET = 'AIRPORTS_SELECTOR_TARGET';
export const DATES_TARGET = 'DATES_TARGET';

export const isAirportsFilledLeg = leg => {
    return !!(leg.origin && leg.destination
        && leg.origin.hasOwnProperty('code') && leg.destination.hasOwnProperty('code'));
};

export const isFilledLeg = leg => {
    return !!(isAirportsFilledLeg(leg) && leg.dateStart && (leg.dateStart instanceof moment));
};

export const isWellFilledLeg = leg => isFilledLeg(leg) && !leg.errors.length;

const legsErrorController = (legs) => {
    if (!Array.isArray(legs)) {
        return legs;
    }

    for (let i=0; i<legs.length; i++) {
        const leg = legs[i];
        validateDuplicatedCityPairsErrors(leg, i, legs);
        validateInconsistentDatesErrors(leg, i, legs);
    }

    return legs;
};

const validateDuplicatedCityPairsErrors = (leg, legIdx, legs) => {
    if (!leg.origin || !leg.destination || !leg.origin.hasOwnProperty('code') || !leg.destination.hasOwnProperty('code')) {
        return leg;
    }

    const duplicatedCityPair = legs.some((l, idx) => {
        return legIdx !== idx
            && l.origin && l.destination
            && l.origin.hasOwnProperty('code') && l.destination.hasOwnProperty('code')
            && l.origin.code === leg.origin.code && l.destination.code === leg.destination.code;
    });

    if (duplicatedCityPair) {
        const error = {target: AIRPORTS_SELECTOR_TARGET, type: DUPLICATED_CITY_PAIR_ERROR_KEY};
        leg.errors.push(error);
    } else {
        leg.errors = leg.errors.filter(e => e.type !== DUPLICATED_CITY_PAIR_ERROR_KEY);
    }

    return leg;
};

const validateInconsistentDatesErrors = (leg, legIdx, legs) => {
    if (!leg.dateStart || !leg.dateStart instanceof moment) {
        return leg;
    }

    const hasInconsistentDates = [...legs].splice(0, legIdx).some((prevLeg, idx) => {
        if (!prevLeg.dateStart || legIdx === idx || !prevLeg.dateStart instanceof moment) {
            return false;
        }

        return legIdx !== idx
            && prevLeg.dateStart && prevLeg.dateStart instanceof moment
            && leg.dateStart.isBefore(prevLeg.dateStart);
    });

    if (hasInconsistentDates) {
        const error = {target: DATES_TARGET, type: DATES_OVERLAPPING_ERROR_KEY};
        leg.errors.push(error);
    } else {
        leg.errors = leg.errors.filter(e => e.type !== DATES_OVERLAPPING_ERROR_KEY);
    }

    return leg;
};

export default legsErrorController;